/**
 * formatDate — конвертирует строку с датой между форматами
 * - ISO формат (YYYY-MM-DD)  →  американский (MM/DD/YYYY)
 * - американский (MM/DD/YYYY) → ISO формат (YYYY-MM-DD), если указан reverse
 *
 * @param {string} date - строка даты ("2025-08-22" или "08/22/2025")
 * @param {boolean} reverse - если true, преобразует из MM/DD/YYYY в YYYY-MM-DD
 * @returns {string|null} - отформатированная дата или null, если дата не указана
 */
export default function formatDate(date, reverse) {
	// Если дата пустая или undefined/null → возвращаем null
	if (!date) return null;

	// Если передан reverse === true
	if (reverse) {
		// Ожидаем строку вида "MM/DD/YYYY"
		// Разбиваем её по символу "/"
		const [ month, day, year ] = date.split("/");

		// Склеиваем обратно в ISO формат "YYYY-MM-DD"
		return `${ year }-${ month }-${ day }`;
	}

	// Иначе (reverse === false или не передан)
	// Ожидаем строку вида "YYYY-MM-DD"
	// Разбиваем её по символу "-"
	const [ year, month, day ] = date.split("-");

	// Склеиваем в формат "MM/DD/YYYY"
	return `${ month }/${ day }/${ year }`;
}

// formatDate("2025-08-22");        // "08/22/2025"
// formatDate("08/22/2025", true);  // "2025-08-22"
// formatDate(null);                // null
